import { Helmet } from "react-helmet-async";
// @mui
import { Container, Typography } from "@mui/material";
// components
import { useSettingsContext } from "../../components/settings";
import { useEffect } from "react";
import { CRM_FORMS, crmFormScript } from "../../api/bitrix/accountConfig";

// ----------------------------------------------------------------------

export default function TechnicalSupportPage() {
  const { themeStretch } = useSettingsContext();

  useEffect(() => {
    const bitrixFormDiv = document.getElementById("bitrix-form");
    if (bitrixFormDiv && !bitrixFormDiv.innerText) {
      const script = document.createElement("script");
      script.setAttribute("data-b24-form", CRM_FORMS.technicalSupport.id);
      script.setAttribute("data-skip-movin", "true");
      script.textContent = crmFormScript(CRM_FORMS.technicalSupport);

      bitrixFormDiv.appendChild(script);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> Soporte Técnico | Parnerus</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "xl"}>
        <Typography variant="h3" component="h1" paragraph>
          Soporte Técnico
        </Typography>

        <Typography gutterBottom>
          Complete el siguiente formulario para recibir soporte técnico.
        </Typography>

        <div
          id="bitrix-form"
          style={{ padding: "24px", marginTop: "32px" }}
        ></div>
      </Container>
    </>
  );
}
